import clsx from 'clsx'
import { useState, useEffect, useMemo } from 'react'
import LoaderAdm from '../../../../../../../assets/svgIcons/LoaderAdm.json'
import { sileo } from 'sileo'
import businessApi from '../../../../../../../api/business.api'

// utils
import { formatCurrency, formatDate } from '../../../../../../utils/formatter'
import { formatAccountBankName, formatAccountNumber } from '../accountLabel.utils'

// MUI
//import BlockIcon from '@mui/icons-material/Block'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import SearchIcon from '@mui/icons-material/Search'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

// data
//import { colsMovimientos as cols } from '../../../../../data/headersTables'
import { bankIcons } from '../data'
import iconoEnlace from '../../../../../../../assets/iconos/iconEnlace.png'

// components
import { Text, ForeignAmountDetail } from '../../../../../ui'
import ModalDialogMotionEditForm from '../../../../../modalDialogEditarMovBancario/ModalDialogMotionEditForm'
import ModalComentarios from './ModalComentarios'
import ModalViewAdministracion from '../../../../../ui/tables/baseTable/ModalViewAdministracion'
import RowToggle from '../../common/RowToggle'

// assets
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import StarIcon from '@mui/icons-material/StarOutlineOutlined'
import StarFullIcon from '@mui/icons-material/StarOutlined'
import ComentarioIcon from '@mui/icons-material/SpeakerNotesOutlined'
import Lottie from 'lottie-web'
//import { OrganizationAPI } from '../../../../../../../api/organization.api'
//import GlobalContext from '../../../../../../../context/global-context'
//import { BankAPI } from '../../../../../../../api/bancos.api'

const TableMovements = ({
  rows,
  getData,
  businessId,
  highlightedRows,
  toggleHighlight,
  order,
  onSort,
  hasBankLinked,
  onAddBank,
  loading,
  groupedRows
}) => {
  //const [page] = useState(0)
  const [comprobanteRow, setComprobanteRow] = useState(null)
  const [idLibro, setIdLibro] = useState()
  const [open, setOpen] = useState(false)
  const [commentModal, setCommentModal] = useState({
    open: false,
    rowId: null
  })
  const [commentsByRow, setCommentsByRow] = useState({})
  const [switchGetData, setSwitchGetData] = useState(false)
  const [noConsiderados] = useState(new Set())
  const [expandedGroups, setExpandedGroups] = useState({})
  //const organizationAPI = new OrganizationAPI()
  //const bancoAPI = new BankAPI()
  //const { currentBusiness } = useContext(GlobalContext)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }))
  }

  const isConciliarDisabled = id => noConsiderados.has(id)

  const styles = {
    table: 'w-full min-w-[1080px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 sm:px-2 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-1 sm:px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[70px] sm:max-w-[80px]',
    wideCol: 'w-auto max-w-[220px] sm:max-w-[300px]',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem]',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-400 font-medium',
    dateHeader: 'bg-gray-50/80 backdrop-blur-sm border-y border-gray-200/50 py-2 px-4 text-left font-bold text-primary flex items-center gap-2 cursor-pointer hover:bg-gray-100 transition-colors group font-sans'
  }


  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'nombreCuentaBanco' },
    { col: 'Descripción', field: 'descripcion' },
    { col: 'Abono', field: 'montoAbono' },
    { col: 'Cargo', field: 'montoCargo' },
    { col: 'Status', field: 'status' },
    { col: 'Confianza', field: 'confianza' },
    { col: 'Acciones', field: 'aprobado' },
    { col: 'Comentarios', field: null }
  ]

  const renderAsientoContable = row => {
    if (row.isGroup) return null
    return (
      <div className={styles.text}>
        {row.codigoCuenta && <div>{row.codigoCuenta}</div>}
        <div className='flex items-center justify-center gap-1 whitespace-nowrap'>
          {row.comprobante && row.id ? (
            <button
              type='button'
              className='text-accent2 underline cursor-pointer'
              aria-label={'Abrir comprobante ' + row.comprobante}
              onClick={() => setComprobanteRow(row)}
            >
              {row.comprobante}
            </button>
          ) : <span>—</span>}
          <span>@{row.usuarioAsignador || 'Luca'}</span>
        </div>
      </div>
    )
  }

  const comprobanteModal = comprobanteRow && (
    <ModalViewAdministracion
      openModal={Boolean(comprobanteRow)}
      setOpenModal={value => {
        if (!value) setComprobanteRow(null)
      }}
      comprobanteId={comprobanteRow.id}
      validation={1}
      folio={comprobanteRow.nombreFolio}
      numeroFolio={comprobanteRow.folio}
    />
  )

  const handleClickOpen = idLibro => {
    setIdLibro(idLibro)
    setOpen(true)
  }

  const handleOpenComments = rowId => {
    setCommentModal({
      open: true,
      rowId
    })
  }

  const handleCloseComments = () => {
    setCommentModal({
      open: false,
      rowId: null
    })
  }

  const rowCommentsById = useMemo(() => {
    const mappedComments = {}

    if (!Array.isArray(rows)) return mappedComments

    rows.forEach(row => {
      if (row?.id == null) return

      const commentValue = row?.comentario ?? row?.comment
      if (commentValue == null) return

      mappedComments[row.id] = String(commentValue)
    })

    return mappedComments
  }, [rows])

  const handleSaveComment = async comment => {
    if (!businessId || commentModal.rowId == null) {
      sileo.error({
        title: 'Error al guardar',
        description: 'No se pudo identificar el movimiento para guardar el comentario.'
      })
      return
    }

    const normalizedComment = String(comment || '')

    await sileo.promise(
      businessApi.postComentarioMovimiento(businessId, commentModal.rowId, normalizedComment),
      {
        loading: { title: 'Guardando comentario' },
        success: {
          title: 'Comentario guardado',
          description: (
            <span className='text-green-500/80 font-medium'>
              El comentario del movimiento se guardo correctamente.
            </span>
          )
        },
        error: {
          title: 'Error al guardar',
          description: 'No se pudo guardar el comentario del movimiento.'
        }
      }
    )

    setCommentsByRow(prev => {
      return {
        ...prev,
        [commentModal.rowId]: normalizedComment
      }
    })

    handleCloseComments()
    void Promise.resolve(getData?.())
  }

  useEffect(() => {
    if (switchGetData) {
      getData()
      setSwitchGetData(false)
    }
  }, [switchGetData])

  const getBankIcon = bankName => bankIcons[bankName] || imgDefaultBank

  const getBankIconClass = bankName =>
    bankName === 'Global66' ? 'h-6 w-6 object-contain rounded' : 'h-6 w-auto rounded'

  const StarCell = ({ rowId, isGroup = false, groupIds = null, indented = false, bankName = null }) => {
    const isHighlighted = isGroup ? groupIds?.every(id => highlightedRows[id]) : highlightedRows[rowId]
    const ids = isGroup ? groupIds : rowId
    const fontSize = isGroup ? '1.2rem' : '1rem'
    const iconKey = bankName || rowId

    return (
      <div className={clsx('flex items-center gap-1', { 'pl-8': indented, 'pl-0.5': isGroup && !indented })}>
        {isHighlighted ? (
          <StarFullIcon
            style={{ color: '#FFD700', cursor: 'pointer', fontSize }}
            onClick={(e) => {
              e.stopPropagation()
              toggleHighlight(ids)
            }}
          />
        ) : (
          <StarIcon
            style={{ color: '#a1a1aa', cursor: 'pointer', fontSize }}
            onClick={(e) => {
              e.stopPropagation()
              toggleHighlight(ids)
            }}
          />
        )}
        {!indented && (
          <img
            src={isGroup ? getBankIcon('Mercado Pago') : getBankIcon(iconKey)}
            className={clsx(
              getBankIconClass(isGroup ? 'Mercado Pago' : iconKey),
              (isGroup || iconKey?.toLowerCase().includes('mercado')) && '-ml-1'
            )}
          />
        )}
      </div>
    )
  }


  /*const handleToggleAprobado = async row => {
    const yaNoConsiderado = noConsiderados.has(row.id)

    if (yaNoConsiderado) {
      setNoConsiderados(prev => {
        const nuevo = new Set(prev)
        nuevo.delete(row.id)
        return nuevo
      })
      return
    }

    try {
      setLoading(true)
      const response = await bancoAPI.getDataLibros(currentBusiness?.id, row.id)
      const linkage = response.data.linkage || []
      const ids = linkage.map(link => link.idPrincipal)
      const payload = { ids: ids.map(Number) }

      if (ids.length > 0) {
        await organizationAPI.postDesvincular(
          { businessId: currentBusiness?.id, idLibro: row.id },
          payload
        )
      }

      setNoConsiderados(prev => {
        const nuevo = new Set(prev)
        nuevo.add(row.id)
        return nuevo
      })

      setSwitchGetData(true)
    } catch (error) {
      console.error('Error al intentar desvincular:', error)
    } finally {
      setLoading(false)
    }
  }*/

  //const searchColsIndex = col => orderableCols.find(item => item.col === col)

  // ⇒ Renderizado condicional:
  // 1) Si hay filas (rows.length > 0), dibujar la tabla.
  // 2) Si no hay filas y aún NO se cumplió el timeout de 15 s, mostrar Lottie.
  // 3) Si no hay filas y ya SE CUMPLIÓ el timeout (showNoData === true), mostrar mensaje con lupa.

  const hasRows = Array.isArray(rows) && rows.length > 0

  const getDescription = (descripcion) => {
    if (!descripcion) return '<descripcion>'
    const normalized = descripcion.toLowerCase()
    if (normalized === 'payout' || normalized === 'payment') return 'Transferencia'
    return descripcion
  }

  const normalizeStatus = status =>
    String(status || '')
      .toUpperCase()
      .replace(/_/g, ' ')
      .trim()

  const getStatusLabel = status => {
    const normalized = normalizeStatus(status)
    if (!normalized) return '—'
    if (normalized === 'PARCIALMENTE CONCILIADO') return 'PARCIALMENTE CONCILIADO'
    if (normalized === 'CONCILIADO') return 'CONCILIADO'
    if (normalized === 'PENDIENTE') return 'PENDIENTE'
    return normalized
  }

  const statusBadgeClass = status => {
    const normalized = normalizeStatus(status)
    const isPending = normalized === 'PENDIENTE'
    const isConciliado = normalized === 'CONCILIADO'
    const isPartial = normalized === 'PARCIALMENTE CONCILIADO'
    const isUnknown = !normalized || (!isPending && !isConciliado && !isPartial)
    return clsx(
      'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.55rem] sm:text-[0.6rem] font-semibold uppercase tracking-wider leading-tight',
      {
        'text-danger bg-danger/10': isPending,
        'text-success bg-success/10': isConciliado,
        'text-amber-700 bg-amber-100': isPartial,
        'text-muted bg-border/40': isUnknown
      }
    )
  }

  const getScoreLabel = row => {
    if (row.nombreCuentaBanco === 'Caja Principal') return '100%'
    if (row.score !== undefined && row.score !== null) {
      return String(row.score).replace('score: ', '')
    }
    return '—'
  }

  const renderScore = row => {
    const label = getScoreLabel(row)
    const match = label.match(/^(\d+(?:[.,]\d+)?\s*%)\s*(.*)$/)
    const percentage = match ? match[1] : label
    const name = match?.[2]?.trim().replace(/^@/, '')
    return (
      <div className='flex flex-col items-center'>
        <Text className={styles.boldText}>{percentage}</Text>
        {name && <span className={styles.text}>@{name}</span>}
      </div>
    )
  }

  const renderHighlightButton = (isHighlighted, onClick, size = 18) => (
    <button
      type='button'
      className='pt-0.5'
      onClick={onClick}
      aria-label={isHighlighted ? 'Quitar destacado' : 'Marcar destacado'}
    >
      {isHighlighted ? (
        <StarFullIcon style={{ color: '#FFD700', fontSize: size }} />
      ) : (
        <StarIcon style={{ color: '#a1a1aa', fontSize: size }} />
      )}
    </button>
  )

  const renderActionItem = ({
    label,
    icon = null,
    onClick,
    active = false,
    disabled = false,
    orientation = 'vertical',
    sizeClass = 'w-8 h-8',
    labelClass
  }) => {
    const isVertical = orientation === 'vertical'
    const isInteractive = typeof onClick === 'function'

    return (
      <div
        className={clsx(
          'text-gray-500',
          isVertical ? 'flex flex-col items-center justify-center text-xs' : 'flex items-center gap-2'
        )}
      >
        <button
          type='button'
          onClick={(event) => {
            if (!isInteractive || disabled) return
            onClick(event)
          }}
          className={clsx(
            'flex items-center justify-center rounded-full shadow-full-xs',
            sizeClass,
            {
              'bg-accent2 text-white': active,
              'bg-white text-slate-400': !active,
              'opacity-50 cursor-not-allowed': disabled,
              'hover:cursor-pointer': isInteractive && !disabled
            }
          )}
          aria-label={`${label} movimiento`}
        >
          {icon ?? <span className='block h-5 w-5' aria-hidden='true' />}
        </button>
        <Text
          className={
            labelClass ??
            (isVertical ? 'mt-2 whitespace-nowrap' : 'text-[11px] whitespace-nowrap')
          }
        >
          {label}
        </Text>
      </div>
    )
  }

  const getCommentValue = rowId => {
    if (rowId == null) return ''

    if (Object.prototype.hasOwnProperty.call(commentsByRow, rowId)) {
      return commentsByRow[rowId] || ''
    }

    return rowCommentsById[rowId] || ''
  }

  const hasComment = rowId => Boolean(getCommentValue(rowId).trim())

  const renderCommentAction = ({ rowId, orientation = 'vertical', sizeClass = 'w-8 h-8' }) =>
    renderActionItem({
      label: 'Comentarios',
      orientation,
      sizeClass,
      active: hasComment(rowId),
      onClick: () => handleOpenComments(rowId),
      icon: <ComentarioIcon className='w-5 h-5' />
    })

  const renderGroupCard = row => {
    const groupIds = Array.isArray(row.subRows) ? row.subRows.map(r => r.id) : []
    const isHighlighted = groupIds.length > 0 && groupIds.every(id => highlightedRows[id])
    const isExpanded = Boolean(expandedGroups[row.id])
    return (
      <div className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
        <div className='flex items-start justify-between gap-2'>
          <div className='flex items-start gap-2'>
            {renderHighlightButton(isHighlighted, () => toggleHighlight(groupIds))}
            <img
              src={getBankIcon(row.nombreCuentaBanco)}
              alt='Banco'
              className={getBankIconClass(row.nombreCuentaBanco)}
            />
            <div>
              <Text className='text-xs font-bold'>
                {row.fecha ? formatDate(row.fecha) : 'Sin fecha'}
              </Text>
              {renderAsientoContable(row)}
              <Text className='text-[11px] text-gray-500'>
                {formatAccountBankName(row.nombreCuentaBanco, row.cuentaTipoId) || 'Cuenta'}
              </Text>
            </div>
          </div>
          <button
            type='button'
            className='flex items-center justify-center w-8 h-8 rounded-full bg-gray-100'
            onClick={() => toggleGroup(row.id)}
            aria-label={isExpanded ? 'Ocultar detalle' : 'Ver detalle'}
          >
            <KeyboardArrowDownIcon
              className={clsx('transition-transform', { 'rotate-180': isExpanded })}
            />
          </button>
        </div>

        <div className='mt-2'>
          <Text className='text-[10px] text-gray-400'>Descripción</Text>
          <Text className='text-xs font-semibold'>{getDescription(row.descripcion)}</Text>
        </div>

        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          <div>
            <Text className='text-[10px] text-gray-400'>Abono</Text>
            <Text className='text-sm font-bold'>{formatCurrency(row.montoAbono)}</Text>
            <ForeignAmountDetail movement={row} amount={row.montoAbono} />
          </div>
          <div className='text-right'>
            <Text className='text-[10px] text-gray-400'>Cargo</Text>
            <Text className='text-sm font-bold'>{formatCurrency(row.montoCargo)}</Text>
            <ForeignAmountDetail movement={row} amount={row.montoCargo} />
          </div>
        </div>
      </div>
    )
  }

  const renderRowCard = (row, isGroupedDetail) => {
    const isHighlighted = Boolean(highlightedRows[row.id])
    const isDisabled = loading || isConciliarDisabled(row.id)
    return (
      <div
        className={clsx(
          'rounded-2xl border border-gray-100 bg-white shadow-sm p-3',
          isGroupedDetail && 'bg-gray-100'
        )}
      >
        <div className='flex items-start justify-between gap-2'>
          <div className='flex items-start gap-2'>
            {renderHighlightButton(isHighlighted, () => toggleHighlight(row.id))}
            <img
              src={getBankIcon(row.nombreCuentaBanco)}
              alt='Banco'
              className={getBankIconClass(row.nombreCuentaBanco)}
            />
            <div>
              <Text className='text-xs font-bold'>
                {formatAccountBankName(row.nombreCuentaBanco, row.cuentaTipoId) || 'Cuenta'}
              </Text>
              {row.numeroCuentaBanco && row.nombreCuentaBanco !== 'Caja Principal' && (
                <Text className='text-[11px] text-gray-500'>
                  {formatAccountNumber(row.numeroCuentaBanco, row.cuentaTipoId)}
                </Text>
              )}
            </div>
          </div>
          <Text className={statusBadgeClass(row.status)}>
            {getStatusLabel(row.status)}
          </Text>
        </div>

        <div className='mt-2'>
          <Text className='text-[10px] text-gray-400'>Fecha</Text>
          <Text className='text-xs font-semibold'>
            {row.fecha ? formatDate(row.fecha) : 'Sin fecha'}
          </Text>
          {renderAsientoContable(row)}
        </div>

        <div className='mt-2'>
          <Text className='text-[10px] text-gray-400'>Descripción</Text>
          <Text className='text-xs font-semibold'>{getDescription(row.descripcion)}</Text>
        </div>

        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
          <div>
            <Text className='text-[10px] text-gray-400'>Abono</Text>
            <Text className='text-sm font-bold'>{formatCurrency(row.montoAbono)}</Text>
            <ForeignAmountDetail movement={row} amount={row.montoAbono} />
          </div>
          <div className='text-right'>
            <Text className='text-[10px] text-gray-400'>Cargo</Text>
            <Text className='text-sm font-bold'>{formatCurrency(row.montoCargo)}</Text>
            <ForeignAmountDetail movement={row} amount={row.montoCargo} />
          </div>
        </div>

        <div className='mt-2 flex items-center justify-between'>
          <div>
            <Text className='text-[10px] text-gray-400'>Confianza</Text>
            {renderScore(row)}
          </div>
          <div className='flex items-center gap-4'>
            {renderActionItem({
              label: 'Conciliar',
              orientation: 'horizontal',
              sizeClass: 'w-9 h-9',
              active: row.status === 'CONCILIADO',
              disabled: isDisabled,
              onClick: () => handleClickOpen(row.id),
              icon: (
                <img
                  src={iconoEnlace}
                  alt='icono enlace'
                  className={clsx('w-5 h-5', {
                    'brightness-200': row.status === 'CONCILIADO'
                  })}
                />
              )
            })}
            {renderCommentAction({
              rowId: row.id,
              orientation: 'horizontal',
              sizeClass: 'w-9 h-9'
            })}
          </div>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <Lottie animationData={LoaderAdm} loop style={{ width: 220, height: 220 }} />
    )
  }

  if (!hasRows) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <SearchIcon fontSize="large" className="mb-4 text-gray-400" />
        <Text>
          {hasBankLinked
            ? 'No existen movimientos para el periodo seleccionado'
            : 'Conecta tu banco para ver los movimientos'}
        </Text>

        {/* CTA solo si NO hay banco y existe el handler */}
        {!hasBankLinked && !!onAddBank && (
          <button
            onClick={onAddBank}
            className="mt-3 rounded-full bg-accent2 text-white text-sm px-4 py-2"
            type="button"
          >
            AGREGAR BANCO
          </button>
        )}
      </div>
    )
  }

  if (isMobile) {
    return (
      <div className='space-y-3 font-sans'>
        {groupedRows ? (
          Object.entries(groupedRows).map(([date, groupRows]) => (
            <div key={date} className='space-y-3'>
              {groupRows.map((row, i) => {
                if (row.isGroup) {
                  const isExpanded = Boolean(expandedGroups[row.id])
                  return (
                    <div key={`${date}-group-${row.id || i}`} className='space-y-2'>
                      {renderGroupCard(row)}
                      {isExpanded &&
                        row.subRows?.map((subRow, j) => (
                          <div key={`${row.id}-sub-${subRow.id || j}`}>
                            {renderRowCard(subRow, true)}
                          </div>
                        ))}
                    </div>
                  )
                }
                return (
                  <div key={`${date}-row-${row.id || i}`}>
                    {renderRowCard(row)}
                  </div>
                )
              })}
            </div>
          ))
        ) : (
          rows.map((row, i) => (
            <div key={row?.id ?? i}>{renderRowCard(row)}</div>
          ))
        )}
        {open && (
          <ModalDialogMotionEditForm
            open={open}
            handleClose={() => setOpen(false)}
            setOpen={setOpen}
            libroId={idLibro}
            setSwitchGetData={setSwitchGetData}
          />
        )}
        {comprobanteModal}
        <ModalComentarios
          open={commentModal.open}
          onClose={handleCloseComments}
          onSave={handleSaveComment}
          initialValue={getCommentValue(commentModal.rowId)}
          rowId={commentModal.rowId}
        />
      </div>
    )
  }

  // Si llegamos aquí, significa que hasRows === true ⇒ hay datos para pintar la tabla:
  return (
    <>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            {orderableCols.map(({ col, field }, i) => (
              <th key={i}
                className={clsx(
                  styles.th,
                  { 'cursor-pointer': field },
                  i === 0 && styles.smallCol
                )}
                onClick={() => field && onSort({ col, field })}>
                {col}
                {order.col === col && (
                  <KeyboardArrowDownIcon
                    className={clsx('transition-all ml-2 cursor-pointer', {
                      'opacity-40': order.col !== col,
                      'rotate-180': order.direction === 'desc'
                    })}
                  />
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {groupedRows ? (
            Object.entries(groupedRows).map(([date, groupRows]) => (
              <>
                {groupRows.map((row, i) => {
                  if (row.isGroup) {
                    const isExpanded = expandedGroups[row.id]
                    const groupIds = row.subRows.map(r => r.id)

                    return (
                      <>
                        <tr
                          className={clsx(styles.tr, 'cursor-pointer')}
                          key={`${date}-${i}-group`}
                          onClick={() => toggleGroup(row.id)}
                        >
                          <td className={clsx(styles.td, styles.smallCol)}>
                            <StarCell isGroup={true} groupIds={groupIds} />
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <Text className={styles.boldText}>{formatDate(row.fecha)}</Text>
                            {renderAsientoContable(row)}
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <Text className={styles.boldText}>
                              {formatAccountBankName(row.nombreCuentaBanco, row.cuentaTipoId)}
                            </Text>
                          </td>
                          <td className={clsx(styles.td, styles.wideCol)}>
                            <Text className={styles.boldText}>{getDescription(row.descripcion)}</Text>
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <Text className={clsx(styles.boldText, 'font-bold')}>{formatCurrency(row.montoAbono)}</Text>
                            <ForeignAmountDetail movement={row} amount={row.montoAbono} />
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <Text className={clsx(styles.boldText, 'font-bold')}>{formatCurrency(row.montoCargo)}</Text>
                            <ForeignAmountDetail movement={row} amount={row.montoCargo} />
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <Text className={clsx(styles.boldText)}></Text>
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <Text className={clsx(styles.boldText)}></Text>
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <div className="flex h-full items-center justify-center space-x-3">
                              <RowToggle
                                isExpanded={isExpanded}
                                onClick={() => toggleGroup(row.id)}
                              />
                            </div>
                          </td>
                          <td className={clsx(styles.td, styles.mediumCol)}>
                            <Text className={clsx(styles.boldText)}></Text>
                          </td>
                        </tr>

                        {isExpanded && row.subRows.map((subRow, j) => (
                          <tr className={clsx(styles.tr, 'bg-gray-50')} key={`${date}-${i}-sub-${j}`}>
                            <td className={clsx(styles.td, styles.smallCol)}>
                              <StarCell rowId={subRow.id} indented={true} />
                            </td>

                            <td className={clsx(styles.td, styles.mediumCol)}>
                              <Text className={styles.boldText}>{subRow.fecha && formatDate(subRow.fecha)}</Text>
                              {renderAsientoContable(subRow)}
                            </td>

                            <td className={clsx(styles.td, styles.mediumCol)}>
                              <Text className={styles.boldText}>
                                {formatAccountBankName(subRow.nombreCuentaBanco, subRow.cuentaTipoId)}
                              </Text>
                              <Text className={styles.text}>
                                {formatAccountNumber(subRow.numeroCuentaBanco, subRow.cuentaTipoId)}
                              </Text>
                            </td>

                            <td className={clsx(styles.td, styles.wideCol)}>
                              <Text className={styles.boldText}>{getDescription(subRow.descripcion)}</Text>
                            </td>

                            <td className={clsx(styles.td, styles.mediumCol)}>
                              <Text className="font-bold text-[0.65rem]">{formatCurrency(subRow.montoAbono)}</Text>
                              <ForeignAmountDetail movement={subRow} amount={subRow.montoAbono} />
                            </td>
                            <td className={clsx(styles.td, styles.mediumCol)}>
                              <Text className="font-bold text-[0.65rem]">{formatCurrency(subRow.montoCargo)}</Text>
                              <ForeignAmountDetail movement={subRow} amount={subRow.montoCargo} />
                            </td>

                            <td className={clsx(styles.td, styles.mediumCol)}>
                          <Text className={statusBadgeClass(subRow.status)}>
                            {getStatusLabel(subRow.status)}
                          </Text>
                            </td>

                            <td className={clsx(styles.td, styles.mediumCol)}>
                              {subRow.score != null ? renderScore(subRow) : null}
                            </td>

                            <td className={clsx(styles.td, styles.mediumCol)}>
                              <div className="flex h-full items-center justify-center">
                                {renderActionItem({
                                  label: 'Conciliar',
                                  active: subRow.status === 'CONCILIADO',
                                  disabled: loading || isConciliarDisabled(subRow.id),
                                  onClick: (e) => {
                                    e.stopPropagation()
                                    handleClickOpen(subRow.id)
                                  },
                                  icon: (
                                    <img
                                      src={iconoEnlace}
                                      alt="icono enlace"
                                      className={clsx('w-5 h-5 transition-all duration-300', {
                                        'brightness-200': subRow.status === 'CONCILIADO'
                                      })}
                                    />
                                  )
                                })}
                              </div>
                            </td>
                            <td className={clsx(styles.td, styles.mediumCol)}>
                              <div className="flex h-full items-center justify-center">
                                {renderCommentAction({ rowId: subRow.id })}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    )
                  }

                  return (
                    <tr className={styles.tr} key={`${date}-${i}`}>
                      <td className={clsx(styles.td, styles.smallCol)}>
                        <StarCell rowId={row.id} bankName={row.nombreCuentaBanco} />
                      </td>

                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <Text className={styles.boldText}>
                          {row.fecha && formatDate(row.fecha)}
                        </Text>
                        {renderAsientoContable(row)}
                      </td>

                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {row.nombreCuentaBanco === 'Caja Principal' ? (
                          <Text className={styles.boldText}>{row.nombreCuentaBanco}</Text>
                        ) : (
                          <>
                            <Text className={styles.boldText}>
                              {formatAccountBankName(row.nombreCuentaBanco, row.cuentaTipoId)}
                            </Text>
                            <Text className={styles.text}>
                              {formatAccountNumber(row.numeroCuentaBanco, row.cuentaTipoId)}
                            </Text>
                          </>
                        )}
                      </td>

                      <td className={clsx(styles.td, styles.wideCol)}>
                        <Text className={styles.boldText}>
                          {getDescription(row.descripcion)}
                        </Text>
                      </td>

                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <Text className={clsx(styles.boldText, 'font-bold')}>
                          {formatCurrency(row.montoAbono)}
                        </Text>
                        <ForeignAmountDetail movement={row} amount={row.montoAbono} />
                      </td>

                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <Text className={clsx(styles.boldText, 'font-bold')}>
                          {formatCurrency(row.montoCargo)}
                        </Text>
                        <ForeignAmountDetail movement={row} amount={row.montoCargo} />
                      </td>

                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <Text className={statusBadgeClass(row.status)}>
                          {getStatusLabel(row.status)}
                        </Text>
                      </td>

                      <td className={clsx(styles.td, styles.mediumCol)}>
                        {row.nombreCuentaBanco === 'Caja Principal' || row.score != null ? renderScore(row) : null}
                      </td>

                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <div className="flex h-full items-center justify-center">
                          {renderActionItem({
                            label: 'Conciliar',
                            active: row.status === 'CONCILIADO',
                            disabled: loading || isConciliarDisabled(row.id),
                            onClick: () => handleClickOpen(row.id),
                            icon: (
                              <img
                                src={iconoEnlace}
                                alt="icono enlace"
                                className={clsx('w-5 h-5 transition-all duration-300', {
                                  'brightness-200': row.status === 'CONCILIADO'
                                })}
                              />
                            )
                          })}
                        </div>
                      </td>
                      <td className={clsx(styles.td, styles.mediumCol)}>
                        <div className="flex h-full items-center justify-center">
                          {renderCommentAction({ rowId: row.id })}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </>
            ))
          ) : (
            rows.map((row, i) => (
              <tr className={styles.tr} key={i}>
                {/* Nombre origen */}
                <td className={clsx(styles.td, styles.smallCol)}>
                  <StarCell rowId={row.id} bankName={row.nombreCuentaBanco} />
                </td>

                {/* Fecha */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <Text className={styles.boldText}>
                    {row.fecha && formatDate(row.fecha)}
                  </Text>
                  {renderAsientoContable(row)}
                </td>

                {/* Cuenta Corriente */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  {row.nombreCuentaBanco === 'Caja Principal' ? (
                    <Text className={styles.boldText}>{row.nombreCuentaBanco}</Text>
                  ) : (
                    <>
                      <Text className={styles.boldText}>
                        {formatAccountBankName(row.nombreCuentaBanco, row.cuentaTipoId)}
                      </Text>
                      <Text className={styles.text}>
                        {formatAccountNumber(row.numeroCuentaBanco, row.cuentaTipoId)}
                      </Text>
                    </>
                  )}
                </td>

                {/* Descripción */}
                <td className={clsx(styles.td, styles.wideCol)}>
                  <Text className={styles.boldText}>
                    {row.descripcion || '<descripcion>'}
                  </Text>
                </td>

                {/* Abono */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <Text className={clsx(styles.boldText, 'font-bold')}>
                    {formatCurrency(row.montoAbono)}
                  </Text>
                  <ForeignAmountDetail movement={row} amount={row.montoAbono} />
                </td>

                {/* Cargo */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <Text className={clsx(styles.boldText, 'font-bold')}>
                    {formatCurrency(row.montoCargo)}
                  </Text>
                  <ForeignAmountDetail movement={row} amount={row.montoCargo} />
                </td>

                {/* Status */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <Text className={statusBadgeClass(row.status)}>
                    {getStatusLabel(row.status)}
                  </Text>
                </td>

                {/* Confianza */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  {row.nombreCuentaBanco === 'Caja Principal' || row.score != null ? renderScore(row) : null}
                </td>

                {/* Acciones */}
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <div className="flex h-full items-center justify-center">
                    {/* Botón Conciliar */}
                    <div className="flex flex-col text-xs text-gray-500 items-center justify-center">
                      <div
                        className={clsx(
                          'flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8',
                          {
                            'bg-[#fff]': row.status !== 'CONCILIADO',
                            'bg-accent2 text-white': row.status === 'CONCILIADO',
                            'opacity-50 cursor-not-allowed':
                              loading || isConciliarDisabled(row.id),
                            'hover:cursor-pointer':
                              !loading && !isConciliarDisabled(row.id)
                          }
                        )}
                        onClick={() => {
                          if (!loading && !isConciliarDisabled(row.id)) {
                            handleClickOpen(row.id)
                          }
                        }}
                      >
                        <img
                          src={iconoEnlace}
                          alt="icono enlace"
                          className={clsx('w-5 h-5 transition-all duration-300', {
                            'brightness-200': row.status === 'CONCILIADO'
                          })}
                        />
                      </div>
                      <Text className="mt-2">Conciliar</Text>
                    </div>
                  </div>
                </td>
                <td className={clsx(styles.td, styles.mediumCol)}>
                  <div className="flex h-full items-center justify-center">
                    {renderCommentAction({ rowId: row.id })}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {open && (
        <ModalDialogMotionEditForm
          open={open}
          handleClose={() => setOpen(false)}
          setOpen={setOpen}
          libroId={idLibro}
          setSwitchGetData={setSwitchGetData}
        />
      )}
      {comprobanteModal}
      <ModalComentarios
        open={commentModal.open}
        onClose={handleCloseComments}
        onSave={handleSaveComment}
        initialValue={getCommentValue(commentModal.rowId)}
        rowId={commentModal.rowId}
      />
    </>
  )
}

export default TableMovements
